import React, { forwardRef } from "react"
import {
  Card,
  CardBody,
  CardHeader,
  CardText,
  CardTitle,
  Col,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
} from "reactstrap"
import Switch from "react-switch"

const SubCalendarItem = forwardRef(
  (
    {
      updateSubCalendarStatus,
      subCalendarActions,
      isDragging,
      style,
      attributes,
      listeners,
      ...props
    },
    ref
  ) => {
    const inlineStyles = {
      width: isDragging ? "100%" : "",
      height: isDragging ? "100%" : "",
      ...style,
    }

    return (
      <div className="col-xl-3 col-sm-6" ref={ref} style={inlineStyles}>
        <Card className="shadow-sm" style={{ border: "1px solid" }}>
          <CardHeader style={{ background: "transparent" }} className="pb-0">
            <Row className="d-flex justify-content-between">
              <Col xs="auto" {...attributes} {...listeners}>
                <i
                  className="bx bx-menu font-size-20"
                  style={{ cursor: "pointer" }}
                />
              </Col>
              <Col xs="auto">
                <UncontrolledDropdown>
                  <DropdownToggle href="#" className="card-drop" tag="i">
                    <i
                      className="dripicons-gear font-size-14"
                      style={{ cursor: "pointer" }}
                    />
                  </DropdownToggle>
                  {!!subCalendarActions && (
                    <DropdownMenu className="dropdown-menu-end">
                      {subCalendarActions.map((a, index) => (
                        <DropdownItem
                          key={index}
                          href="#"
                          onClick={e => {
                            e.preventDefault()
                            a.onClick(props?.subCalendar)
                          }}
                        >
                          <i className={a.icon} /> {a.name}
                        </DropdownItem>
                      ))}
                    </DropdownMenu>
                  )}
                </UncontrolledDropdown>
              </Col>
            </Row>
          </CardHeader>
          <CardBody>
            <CardTitle className="font-size-16">
              {props?.subCalendar?.name}
            </CardTitle>
            <CardText>
              {props?.subCalendar?.duration_time &&
              props?.subCalendar?.duration_time >= 60
                ? `${Math.floor(props?.subCalendar?.duration_time / 60)}h ${
                    props?.subCalendar?.duration_time % 60
                  }min`
                : `${props?.subCalendar?.duration_time}min`}
            </CardText>
            <Row className="d-flex justify-content-center py-0">
              <Col xs="auto" className="me-2 py-0">
                <Switch
                  checked={props?.subCalendar?.status === 1}
                  onChange={checked =>
                    updateSubCalendarStatus({
                      ...props?.subCalendar,
                      status: checked,
                    })
                  }
                  onColor="#2ECC71"
                  offColor="#E74C3C"
                  name="publishCheck"
                  uncheckedIcon={false}
                  checkedIcon={false}
                  height={16}
                  width={30}
                  handleDiameter={12}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    )
  }
)

export default SubCalendarItem
